export const SAVE_WHD_COLLAPSED_TIERS = 'SAVE_WHD_COLLAPSED_TIERS';

function saveWhdCollapsedTiers(tiersObject) {
  return {
    type: SAVE_WHD_COLLAPSED_TIERS,
    tiersObject
  };
}

export function saveCollapsedTiers(tiersObject) {
  return (dispatch) => {
    dispatch(saveWhdCollapsedTiers(tiersObject));
  };
}
